module.exports = __webpack_public_path__ + "static/media/visa-payment-info.99186fcd.svg";